import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { reactive, ref, onMounted } from "vue";
import type { Ref } from "vue";
import { apiQuery } from "@/api/j24api";

interface mdmServer {
  _id: string;
  customerID: string;
  dataCollection: boolean;
  name: string;
  type: string;
  url: string;
  patchLicense: string;
}

interface SearchResults {
  mdmServer: mdmServer;
  results: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardJamfSearch',
  setup(__props) {

const mdmServers: mdmServer[] = reactive([]);
const mdmServersSelected: Ref<string[]> = ref([]);
const apiResource = ref("/JSSResource/policies");
const apiIdentifier = ref("id");

const secondResource = ref("/JSSResource/policies/id/{id}");
const matchField = ref("policy/package_configuration/packages/package/name");
const matchValue = ref("Word");

const results: SearchResults[] = reactive([]);
const loading = ref(false);

async function getMDMServers() {
  if (mdmServers.length == 0) {
    const result: mdmServer[] = await apiQuery(
      "J24Auth",
      "elaadmin/mdmservers",
      {
        apiAction: "get",
      }
    );
    if (result) {
      result.forEach((mdmServer) => {
        mdmServers.push(mdmServer);
      });
    }
  }
}

async function runSearch() {
  results.length = 0;
  loading.value = true;
  for (const key in mdmServersSelected.value) {
    console.log(key);
    var result;
    const server: mdmServer | undefined = mdmServers.find(
      (server) => server._id == mdmServersSelected.value[key]
    );
    if (server) {
      try {
        result = await apiQuery("ELA", "dashboard/jamfsearch", {
          mdmServerId: mdmServersSelected.value[key],
          firstObject: {
            resource: apiResource.value,
            identifier: apiIdentifier.value,
          },
          secondObject: {
            resource: secondResource.value,
            matchField: matchField.value,
            matchValue: matchValue.value,
          },
        });
        results.push({ mdmServer: server, results: result });
      } catch (error) {
        console.log(error);
        results.push({ mdmServer: server, results: { error: true } });
      }
    }
    //console.log(server);
  }
  loading.value = false;
}

function selectAllMDM() {
  mdmServersSelected.value.length = 0;
  mdmServers.forEach((server) => {
    mdmServersSelected.value.push(server._id);
  });
}

function formatResult(data: any) {
  var text = "";
  if (data.error) {
    return text;
  }
  data.forEach((value: string) => {
    text += JSON.stringify(value, null, 4);
  });
  return text;
}

function printResult(results: any) {
  console.log(results);
  if (results.error) {
    return "Error - Unable to search";
  }
  return "Found " + results.length;
}

onMounted(() => {
  getMDMServers();
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createElementVNode("h2", null, "Search Jamf Instances", -1)
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              chips: "",
              multiple: "",
              label: "Select MDM Servers",
              items: mdmServers,
              "item-title": "name",
              "item-value": "_id",
              modelValue: mdmServersSelected.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mdmServersSelected).value = $event))
            }, null, 8, ["items", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              class: "ma-2",
              onClick: selectAllMDM
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("Select All")
              ])),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              class: "ma-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (mdmServersSelected.value.length = 0))
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Select None")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _cache[11] || (_cache[11] = _createTextVNode("The API resource that the results will be based on. ")),
            _createVNode(_component_v_text_field, {
              label: "API Resource to search",
              modelValue: apiResource.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((apiResource).value = $event))
            }, null, 8, ["modelValue"]),
            _cache[12] || (_cache[12] = _createTextVNode(" The identifier used from the above request for the identifier for the second query. ")),
            _createVNode(_component_v_text_field, {
              label: "Identifier",
              modelValue: apiIdentifier.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((apiIdentifier).value = $event))
            }, null, 8, ["modelValue"]),
            _cache[13] || (_cache[13] = _createTextVNode(" The second API resource to query, {id} will be replaced with the identifier. ")),
            _createVNode(_component_v_text_field, {
              label: "Second Resource",
              modelValue: secondResource.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((secondResource).value = $event))
            }, null, 8, ["modelValue"]),
            _cache[14] || (_cache[14] = _createTextVNode(" Optionally it can only match resources based on the field below. Use slashes to move into the JSON structure. ")),
            _createVNode(_component_v_text_field, {
              label: "Match Field (optional)",
              modelValue: matchField.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((matchField).value = $event))
            }, null, 8, ["modelValue"]),
            _cache[15] || (_cache[15] = _createTextVNode(" Text to match on (matches on field containing this txt) ")),
            _createVNode(_component_v_text_field, {
              label: "Match Value (optional)",
              modelValue: matchValue.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((matchValue).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (runSearch())),
              disabled: loading.value
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [
                _createTextVNode("Run")
              ])),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (results.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(results, (result) => {
          return (_openBlock(), _createBlock(_component_v_row, { key: result }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(result.mdmServer.name) + " - ", 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(printResult(result.results)), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_textarea, {
                    class: "pa-3",
                    "model-value": formatResult(result.results)
                  }, null, 8, ["model-value"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      : _createCommentVNode("", true)
  ], 64))
}
}

})